<template>
  <div style="background-color: #F4FFFA;">
    <choose-institute
      :myIinstitutionEnrollmets="myIinstitutionEnrollmets"
      :instituteApprovalPending="getInstitutionsStatus.institionApproval"
      :defaultInstitutionUserId="defaultInstitutionUserId"
      @defaultInst="defaultInst"
      @addInstitute="$store.state.addInstitute = false"
    ></choose-institute>

    <b-modal
      id="pendingSurveysPopup"
      no-close-on-backdrop
      no-close-on-keyboard
      no-close-on-esc
      hide-header-close
      hide-footer
      size="md"
      title="Pending Surveys"
      centered
    >
      <div v-if="pendingSurveys.hasPendingSurvey">
        <p class="text-muted mb-3">You have pending surveys to complete. Please complete pending surveys to proceed to student dashboard.</p>
        <div
          v-for="survey in pendingSurveys.pending_surveys"
          :key="survey.id"
          class="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
        >
          <div>
            <span class="font-weight-bold" style="font-size: 14px;">{{ survey.name }}</span><br>
            <b-badge v-if="survey.survey_type == 'student_feedback'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="success">
              Instructor Feedback Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'course_exit'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="danger">
              Course Exit Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'programme_exit'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="warning">Programme
              Exit Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'alumini'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="primary">
              Alumini Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'employer'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="secondary">
              Employer Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'parent'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="info">
              Parent Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'faculty'"
              style="font-size: 10px; font-weight: 600; color: #ffffff" pill variant="dark">
              Faculty Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'hod_feedback'"
              style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #8e44ad;" pill>
              HOD Feedback Survey
            </b-badge>
            <b-badge v-if="survey.survey_type == 'class_advisors_feedback'"
              style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #16a085;"
              pill>Class Advisors Feedback Survey</b-badge>
            <b-badge v-if="survey.survey_type == 'infrastructure_feedback'"
              style="font-size: 10px; font-weight: 600; color: #ffffff; background-color: #d35400;"
              pill>Infrastructure Feedback Survey</b-badge>
            <div v-if="survey.academic_year" class="text-muted" style="font-size: 12px;">
              Academic Year: {{ survey.academic_year }}
            </div>
          </div>
          <span v-if="survey.survey_type == 'course_exit'" style="font-weight: bold;">{{survey.course.code}}</span>
          <b-button
            size="sm"
            variant="primary"
            @click="goToSurvey(survey)"
          >Take Survey</b-button>
        </div>
        <b-link v-if="isSurveySkippable" class="text-secondary" @click="skipPendingSurveys()">Skip for now</b-link>
      </div>
      <div v-else class="text-center text-muted">No pending surveys.</div>
    </b-modal>

    <b-modal id="surveyStudentFeedbackModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer modal-class="usersListPendingFull">
      <SurveyAnswers :survey_id="selectedSurveyId" @submitted="onSurveySubmitted('surveyStudentFeedbackModal')" />
    </b-modal>

    <b-modal id="surveyHodFeedbackModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer modal-class="usersListPendingFull">
      <HodSurveyAnswers :survey_id="selectedSurveyId" @submitted="onSurveySubmitted('surveyHodFeedbackModal')" />
    </b-modal>

    <b-modal id="surveyAdvisorFeedbackModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer modal-class="usersListPendingFull">
      <AdvisorSurveyAnswers :survey_id="selectedSurveyId" @submitted="onSurveySubmitted('surveyAdvisorFeedbackModal')" />
    </b-modal>

    <b-modal id="surveyInfrastructureModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer modal-class="usersListPendingFull">
      <SurveyAnswersInfrastructure :survey_id="selectedSurveyId" @submitted="onSurveySubmitted('surveyInfrastructureModal')" />
    </b-modal>

    <b-modal id="surveyCourseExitModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer modal-class="usersListPendingFull">
      <SurveyAnswersCourseExit :survey_id="selectedSurveyId" @submitted="onSurveySubmitted('surveyCourseExitModal')" />
    </b-modal>

    <b-modal
      id="userDataCompletion"
      no-close-on-backdrop
      no-close-on-keyboard
      no-close-on-esc
      hide-footer
      size="lg"
      title="Instititute Questions"
      centered
    >
      <UserDataCompleted
        :currentRole="currentRole"
        @answersSubmitted="$bvModal.hide('userDataCompletion')"
        @skipUserProfileQuestions="skipUserProfileQuestions"
        :userDataQuestions="instituteAttachedQuestions"
      />
    </b-modal>

    <div class="loading" v-if="fetchData || loadInstitutes">
      <load-data></load-data>
    </div>

    <div style="background-color: #F4FFFA;" class="mainContent p-4" v-else>
      <check-institute
        v-if="instituteCreationStatus || selectedInstitute.approved == 0"
        @closeInstituteCreation="$store.commit('enableInstituteCreation')"
        :selectedInstitute="selectedInstitute"
        :myIinstitutionEnrollmets="myIinstitutionEnrollmets"
        :instituteApprovalStatus="instituteApprovalStatus"
      ></check-institute>

      <div v-else>
        <!-- Desktop View -->
        <b-container id="institutionUsersList" v-if="screenWidth > 600">
          <b-row style="margin:0; padding:0;">
            <b-col :md="12">
              <div id="instituteDash">
                <div class="settings" v-if="getInstituteSettingsStatus">
                  <institution-settings
                    :selectedInstitute="selectedInstitute"
                    @updatedSelectedInstitute="updatedSelectedInstitute"
                  ></institution-settings>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>

        <!-- Main Staff Groups Section -->
        <b-row no-gutters style="margin:0; padding:0;">
          <b-col
            md="12"
            :style="{ display: getInstituteSettingsStatus ? 'none' : 'block' }"
          >
            <!-- Mobile Institute Title -->
            <div class="div" v-if="screenWidth <= 600">
              <h4
                class="text-center text-info"
                style="font-weight: 600; font-size: 24px"
                v-b-toggle.instituteSidebar
              >
                {{ selectedInstitute.name }}
              </h4>
            </div>

            <!-- Institute Details -->
            <div class="instituteDetails" style="margin:0; padding:0;">
              <div id="instituteShadowEffect">
                <institute-staff-groups
                  @sufficientTabs="sufficientTabs"
                  :instituteSubTab="instituteSubTab"
                  ref="institutionTabList"
                  :selectedInstitute="selectedInstitute"
                  :myIinstitutionEnrollmets="myIinstitutionEnrollmets"
                  :filteredUniqueInstitutions="filteredUniqueInstitutions"
                  :defaultInstituteId="selectedInstitute.id"
                  :defaultInstitutionUserId="defaultInstitutionUserId"
                  :instituitionAdmin="instituitionAdmin"
                  :isCoe="isCoe"
                  :isAccountsStaff="isAccountsStaff"
                  :canInviteUsers="canInviteUsers"
                  :sendInfo="sendInfo"
                  @changeInstituteRole="changeInstituteRole"
                ></institute-staff-groups>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>


<script>
import InstituitionStaffList from "../components/templates/Dashboard/Institute/InstituitionStaffList.vue";
import InstitutionSettings from "../components/templates/Dashboard/Institute/settings/InstitutionSettings.vue";
import CheckInstitution from "../components/templates/Dashboard/Institute/CheckInstitution.vue";
import InstitutePageSidebar from "../components/templates/Dashboard/Institute/InstitutePageSidebar.vue";
import UserDataCompleted from "./UserDataCompleted.vue";
import acl from "../authorization/acl.js";
import SurveyAnswers from "@/components/templates/Dashboard/survey/SurveyAnswers.vue";
import HodSurveyAnswers from "@/components/templates/Dashboard/survey/HodSurveyAnswers.vue";
import AdvisorSurveyAnswers from "@/components/templates/Dashboard/survey/AdvisorSurveyAnswers.vue";
import SurveyAnswersCourseExit from "@/components/templates/Dashboard/survey/SurveyAnswersCourseExit.vue";
import SurveyAnswersInfrastructure from "@/components/templates/Dashboard/survey/SurveyAnswersProgramExit.vue";

export default {
  computed: {
    loadInstitutes() {
      return this.$store.getters.getInstituteStatus;
    },
    myIinstitutionEnrollmets() {
      return this.$store.getters.getInstitutes;
    },
    getInstitutionsStatus() {
      return this.$store.getters.getInstitutions;
    },
    instituteCreationStatus() {
      return this.$store.getters.instituteCreationStatus;
    },
    instituteApprovalStatus() {
      return this.$store.getters.getInstitutions.institionApproval;
    },
    selectedInstitute() {
      return this.$store.getters.getCurrentInstitution;
    },
    defaultInstitutionUserId() {
      return this.$store.getters.getDefaultInstituteUserId;
    },
    filteredUniqueInstitutions() {
      return this.$store.getters.getFilteredUniqueInstitutions;
    },
    getInstituteSettingsStatus() {
      return this.$store.getters.getInstituteSettings;
    },
  },

  async created() {
    this.fetchData = true;

    if (this.myIinstitutionEnrollmets.length == 0) {
      await this.$store.dispatch("setUpInstitutes");

    }
    await this.handlePermissions();

    await window.addEventListener("resize", this.handleResize);
    await this.handleResize();

    //------------------------------------------------------------------------
    if (this.institutionUserDataObject.length != 0) {
      return (this.fetchData = false);
    }
    await this.getUserInstitutionEnrolls(); //list of enrollment of current user in diffrent institutions with diffrent roles

    if (!this.instituteApprovalStatus && this.selectedInstitute.approved == 0) {
      return (this.fetchData = false);
    }

    const checkUserProfleQuestions = await this.getAttachedQuestions();

    if (checkUserProfleQuestions) {
      let checkProfiledSkipped = await localStorage.getItem(
        "userProfileSkipped"
      );
      let profileStatus;
      if (checkProfiledSkipped == null) {
        profileStatus = false;
      } else {
        profileStatus = true;
      }

      if (
        this.institutionUserDataObject[this.defaultInstitutionUserId] &&
        !this.institutionUserDataObject[this.defaultInstitutionUserId]
          .user_data_completed &&
        !profileStatus &&
        this.instituteAttachedQuestions.length != 0 &&
        (this.institutionUserDataObject[this.defaultInstitutionUserId].role ==
          "student" ||
          this.institutionUserDataObject[this.defaultInstitutionUserId].role ==
          "teacher" ||
          this.institutionUserDataObject[this.defaultInstitutionUserId].role ==
          "admin")
      ) {
        this.currentRole = this.institutionUserDataObject[
          this.defaultInstitutionUserId
        ].role;
        this.$bvModal.show("userDataCompletion");
      }
    }

    this.fetchData = false;

    this.$emit("currentInstitute", {
      selectedInstitute: this.selectedInstitute,
      instituitionAdmin: this.instituitionAdmin,
    });
  },
  async mounted() {
    await this.checkPendingSurveys();
  },
  components: {
    "institute-staff-groups": InstituitionStaffList,
    "institution-settings": InstitutionSettings,
    "check-institute": CheckInstitution,
    "choose-institute": InstitutePageSidebar,
    UserDataCompleted,
    SurveyAnswers,
    HodSurveyAnswers,
    AdvisorSurveyAnswers,
    SurveyAnswersCourseExit,
    SurveyAnswersInfrastructure,
  },

  data() {
    return {
      inviteInstitutionUsers: false,
      screenWidth: 0,
      mobileView: false,
      canInviteUsers: null,
      sendInfo: null,
      instituteChecking: "",
      fetchData: false,

      instituitionAdmin: null,
      isCoe: null,
      isAccountsStaff: null,
      settings: this.$store.getters.defaultInstitute.instituteSettings,
      instituteImage: "",
      institutions: [],
      activeIndex: undefined,

      defaultInstitute: null,
      defaultButton: {
        text: "Default",
        disabled: false,
      },
      defaultInstituteId: null,

      instituteSubTab: null,
      totalUsers: null,
      instituteId: null,

      instituteStatus: false,
      institutionUserDataObject: {},
      currentRole: null,
      instituteAttachedQuestions: [],
      pendingSurveys: [],
      selectedSurveyId: null,
      isSurveySkippable: true,
    };
  },
  methods: {
    async handlePermissions() {
      let userPermissionsData = localStorage.getItem("userPermissions");
      if (userPermissionsData) {
        localStorage.removeItem("userPermissions");
      }


      const isInstitutionAdmin = await acl.isUserGranted(
        "editInstituitionSettings"
      );
      this.instituitionAdmin = isInstitutionAdmin;

      const isCoe = await acl.isUserGranted("controllerOfExamination");
      this.isCoe = isCoe;

      const isAccountsStaff = await acl.isUserGranted("viewFeeManagementTab");
      this.isAccountsStaff = isAccountsStaff;

      const canInviteUsers = await acl.isUserGranted("canInviteUsers");

      this.canInviteUsers = canInviteUsers;

      const sendInfo = await acl.isUserGranted("sendSmsEmail");
      this.sendInfo = sendInfo;
      this.$forceUpdate();
    },
    async updatedSelectedInstitute(institute) {
      this.selectedInstitute = await institute;
      this.$store.state.selectedInstitute = await institute;
    },
    async getSmsCountBalance() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/institution/setting/sms_balence";
      await this.$axios
        .get(url)
        .then((response) => {
          this.$store.state.smsBalance = response.data;
          response;
        })
        .catch((error) => {
          error;
        });
    },
    skipUserProfileQuestions() {
      localStorage.setItem("userProfileSkipped", true);
      this.$bvModal.hide("userDataCompletion");
    },

    async getAttachedQuestions() {
      let status = null;

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        "/institutionuser/institutionuserquestions";
      await this.$axios
        .get(url)
        .then((response) => {
          this.instituteAttachedQuestions = [];
          let questions = response.data;

          questions.forEach((ques) => {
            if (
              this.institutionUserDataObject[this.defaultInstitutionUserId]
                .role == ques.role
            ) {
              this.instituteAttachedQuestions.push({
                id: ques.id,
                description: ques.description,
                name: ques.name,
                role: ques.role,
                input_attributes: ques.input_attributes,
                institution_attributes: ques.institution_attributes,
                answers: ques.answers,
              });
            }
          });

          status = true;
          response;
        })
        .catch((error) => {
          status = false;

          error;
        });

      return status;
    },
    async changeInstituteRole(roleId) {
      await this.$store.dispatch("setDefaultInstitutionUserId", roleId);
      await this.handlePermissions();
      await this.$store.dispatch("setUpInstitutes");
    },
    async inviteUsers() {
      this.inviteInstitutionUsers = await true;
      await this.inviteInstitutionUsers;
      await this.$refs.inviteUsers.prepareInviteUsers();
    },
    sufficientTabs(value) {
      this.instituteSubTab = value;
    },
    async defaultInst(value) {
      await this.setDefaultInstitutionUserId(value);
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    async getUserInstitutionEnrolls() {
      await this.myIinstitutionEnrollmets.forEach((user) => {
        this.$set(this.institutionUserDataObject, user.id, {
          role: user.institution_role.name,
          user_data_completed: user.user_data_completed == 1 ? true : false,
        });
      });
    },



    fileSelect(e) {
      this.instituteImage = e.target.files[0];
      this.instituteImage = URL.createObjectURL(this.instituteImage);
    },
    async skipPendingSurveys() {
      
      const url = this.$store.getters.getAPIKey.mainAPI + `/studfbsurveys/skip`;
      await this.$axios.post(url)
      .then((response) => {
        console.log("Skipped pending surveys");
        if (response.status === 200) {
          this.$bvModal.hide("pendingSurveysPopup");
        }
      })
      .catch(() => {});      

    },
    async onSurveySubmitted(modalId) {
      this.$bvModal.hide(modalId);
      this.$bvModal.hide('pendingSurveysPopup');
      await this.checkPendingSurveys();
    },
    async checkPendingSurveys() {
      const url = this.$store.getters.getAPIKey.pendingSurveysForStudent;
      await this.$axios
        .get(url)
        .then((response) => {
          if (response.data && response.data.hasPendingSurvey) {
            this.pendingSurveys = response.data;
            this.isSurveySkippable = response.data.is_skippable;
            this.$bvModal.show("pendingSurveysPopup");
          }
        })
        .catch(() => {});
    },
    goToSurvey(survey) {
      this.selectedSurveyId = survey.id;
      // this.$bvModal.hide("pendingSurveysPopup");
      console.log("Selected survey:", survey.survey_type, "ID:", survey.id);
      const surveyModalMap = {
        student_feedback: "surveyStudentFeedbackModal",
        hod_feedback: "surveyHodFeedbackModal",
        class_advisors_feedback: "surveyAdvisorFeedbackModal",
        infrastructure_feedback: "surveyInfrastructureModal",
        programme_exit: "surveyInfrastructureModal",
        course_exit: "surveyCourseExitModal",
      };
      const modalId = surveyModalMap[survey.survey_type];
      if (modalId) {
        this.$bvModal.show(modalId);
      }
    },
  },
};
</script>

<style >
#chooseInstituteMobile {
  display: none;
}

#institutionHeading {
  display: none;
  transition: 0.2s;
}

div #institutionUsersList {
  width: 100%;
  /* Full width */
}

#instituteInfo {
  position: relative;
}

#chooseInstitute {
  position: absolute;
  left: -125px;
  top: 270px;
  transform: rotate(-90deg);
  width: 300px;
  border-style: none;
  color: #0066a6;
  font-size: 24px;
}

.instituteDetails {
  background-color: #eeeeeb;
  border-radius: 5px;
}
</style>
